import { allFetch, ResultObj } from "../Domain";

/**
 * 通知目標查詢參數
 */
export interface NotificationTargetSearchParams {
    id: string;
};

/**
 * 通知目標查詢結果
 */
export interface NotificationTargetSearchResItem {
    nt_id: string;
    id: string;
    user_id: string;
    username: string;
    name: string;
    ul_id: string;
    ul_code: string;
    ul_name: string;
    ud_id: string;
    ud_code: string;
    ud_name: string;
};

/**
 * @description 通知目標查詢
 */
export const NotificationTargetSearch = async (
    obj: NotificationTargetSearchParams
): Promise<ResultObj<NotificationTargetSearchResItem[]>> => {
    return await allFetch('Notification/NotificationTargetSearch', obj);
};


/**
 * 通知目標修改參數
 */
export interface NotificationTargetUpdateParams {
    id?: string;
    user_ids: Array<string>;
    ul_ids: Array<string>;
};

/**
 * @description 通知目標修改
 */
export const NotificationTargetUpdate = async (
    obj: NotificationTargetUpdateParams
): Promise<ResultObj> => {
    return await allFetch('Notification/NotificationTargetUpdate', obj);
};